export enum ItemTypes {
    Dashboard = 'dashboard',
    Asset = 'asset',
    Author = 'author',
    Proposal = 'proposal',
    Research = 'research',
}
